import { BadgePercent, Building2, Handshake, MessageCircle, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const BENEFITS = [
    {
        icon: Building2,
        title: "Alquiler y venta",
        text: "Pisos y casas en alquiler o en venta: tú eliges lo que mejor te encaje, en cualquier rincón de España.",
        span: "md:col-span-3",
    },
    {
        icon: BadgePercent,
        title: "Mejores precios",
        text: "Seleccionamos cada inmueble para ofrecerte precios que de verdad merecen la pena.",
        span: "md:col-span-3",
    },
    {
        icon: ShieldCheck,
        title: "Anuncios propios",
        text: "Solo nuestro equipo sube y gestiona los inmuebles. Sin terceros, sin anuncios duplicados y sin sorpresas.",
        span: "md:col-span-2",
    },
    {
        icon: MessageCircle,
        title: "Trato directo por WhatsApp",
        text: "Hablas con nosotros directamente, sin intermediarios ni esperas.",
        span: "md:col-span-2",
    },
    {
        icon: Handshake,
        title: "Todo en persona",
        text: "No pedimos dinero ni documentación por adelantado. Todo se hace en persona, como debe ser.",
        span: "md:col-span-2",
    },
];

export const Benefits = () => (
    <section
        id="por-que"
        className="bg-brand-cream py-20 dark:bg-brand-night sm:py-28"
        data-testid="benefits-section"
    >
        <div className="mx-auto max-w-6xl px-5">
            <SectionHeading
                kicker="Nuestras ventajas"
                title="Por qué Puertalia Portal"
                sub="Un portal inmobiliario hecho para que encontrar casa sea fácil, seguro y sin letra pequeña."
            />
            <div className="mt-12 grid gap-6 md:grid-cols-6">
                {BENEFITS.map((b, i) => (
                    <Reveal key={b.title} delay={i * 0.08} className={b.span}>
                        <div
                            className="group h-full rounded-2xl border border-brand-navy/10 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-orange/40 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
                            data-testid={`benefit-card-${i + 1}`}
                        >
                            <span className="inline-flex rounded-xl bg-brand-navy/5 p-3 text-brand-orange transition-colors duration-300 group-hover:bg-brand-orange group-hover:text-white dark:bg-white/10">
                                <b.icon className="h-6 w-6" strokeWidth={2.2} />
                            </span>
                            <h3 className="mt-5 font-sans text-lg font-bold text-brand-navy dark:text-white">
                                {b.title}
                            </h3>
                            <p className="mt-2 text-sm leading-relaxed text-brand-navy/70 dark:text-white/60">
                                {b.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
